import vars from '../globals';
import youtubePlayer from 'youtube-player';

const $products = $('.products');
const $videoContainer = $products.find('.products__video-container');

let player = null;
let videoName = null;

function setVideoName(item) {
	const arrayFromNames = $videoContainer.data('name').split(' || ');

	videoName = arrayFromNames[item];

	return videoName;
}

function getRandomId() {
	const arrayFromId = $videoContainer.data('video').split(', ');
	const randomItem = Math.floor(Math.random() * arrayFromId.length);
	const id = arrayFromId[randomItem];

	setVideoName(randomItem);

	return id;
}

function createVideo() {
	if ($videoContainer.find('.youtube-video').length) {
		return;
	}

	$videoContainer.append('<video class="youtube-video"></video>');

	const video = $videoContainer.find('.youtube-video').get(0);

	player = youtubePlayer(video, {
		videoId: getRandomId(),
		playerVars: {
			playsinline: 1,
			rel: 0,
			muted: true,
		},
	});

	let interval5sec = null;

	player.on('stateChange', (e) => {
		if (e.data === 0) { // ended
			vars.$document.trigger('video-end', [videoName]);

			clearInterval(interval5sec);
		} else if (e.data === 1) { // started
			vars.$document.trigger('video-start', [videoName]);

			interval5sec = setInterval(() => {
				vars.$document.trigger('video-5sec', [videoName]);
			}, 5000);
		} else if (e.data === 2) { // paused
			clearInterval(interval5sec);
		}
	});

	player.on('ready', () => {
		let isPlaying = false;
		let windowHalfHeight = vars.$window.height() / 2;
		let videoContainerOffsetTop = $videoContainer.offset().top;
		let playVideo = () => {
			const triggerPoint = vars.$window.scrollTop() + windowHalfHeight;

			if (triggerPoint > videoContainerOffsetTop && !isPlaying) {
				isPlaying = true;

				player.playVideo();

				vars.$window.off('.products-video');
			}
		};

		player.mute();

		playVideo();

		if (isPlaying) {
			return;
		}

		vars.$window
			.on('scroll.products-video', playVideo)
			.on('resize.products-video', () => {
				windowHalfHeight = vars.$window.height() / 2;
				videoContainerOffsetTop = $videoContainer.offset().top;
			});
	});
}

function destroyVideo() {
	player.destroy();

	$videoContainer.empty();

	vars.$window.off('.products-video');
}

export default {
	createVideo,
	destroyVideo,
};
